/* FP Article Content Wall
   VERSION: fp-article-content-wall.js@1.0-product-parity-clone

   - Same UI behaviour as product wall (featured, quotes, hover handles, modal)
   - Filters by wall keys (from landing_* article tags or block override)
*/

(function () {
  if (window.__FP_ACW_BOOTED__) return;
  window.__FP_ACW_BOOTED__ = true;

  function safeJsonParse(txt) { try { return JSON.parse(txt || "{}"); } catch (e) { return {}; } }

  function normalizePosts(json) {
    if (!json) return [];
    if (json.posts && typeof json.posts === "object") {
      return Object.keys(json.posts).map(function (k) { return json.posts[k]; }).filter(Boolean);
    }
    if (Array.isArray(json)) return json;
    return [];
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }

  function truncate(s, n) {
    s = String(s || "");
    if (s.length <= n) return s;
    return s.slice(0, Math.max(0, n - 1)).trim() + "…";
  }

  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  function getQuote(p) {
    if (!p || !p.caption) return "";
    var q = (typeof p.caption.quote === "string") ? p.caption.quote : "";
    q = String(q || "").trim().replace(/\s+/g, " ").trim();
    return q;
  }

  function postBucket(p) {
    var t = String((p && (p.postType || p.post_type)) || "").toLowerCase().trim();
    // We keep the product wall buckets so styling + modal behaviour match.
    if (t === "youtube") return "youtube";
    if (t === "vimeo") return "vimeo";
    if (t === "text") return "text";
    if (t.indexOf("video") >= 0) return "instagram_video";
    return "instagram_image";
  }

  function postMediaKind(p) {
    var b = postBucket(p);
    if (b === "instagram_video") return "video";
    return "image";
  }

  function getBestMediaUrl(p, cfg) {
    var media = (p && p.media) ? p.media : {};
    var b = postBucket(p);

    if (b === "text") return "";

    if (b === "youtube" || b === "vimeo") return media.thumbUrl || "";

    var kind = postMediaKind(p);
    if (kind === "video") return media.videoUrl || media.mediaUrl || "";
    if (cfg.preferThumbs && media.thumbUrl) return media.thumbUrl;
    return media.mediaUrl || media.thumbUrl || "";
  }

  function getModalMediaUrl(p) {
    var media = (p && p.media) ? p.media : {};
    var b = postBucket(p);

    if (b === "text") return "";

    if (b === "youtube" || b === "vimeo") return media.videoUrl || "";

    var kind = postMediaKind(p);
    if (kind === "video") return media.videoUrl || media.mediaUrl || "";
    return media.mediaUrl || media.thumbUrl || "";
  }

  function ytId(url) {
    url = String(url || "");
    var m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : "";
  }
  function vimeoId(url) {
    url = String(url || "");
    var m = url.match(/vimeo\.com\/(?:video\/)?([0-9]{6,})/);
    return m ? m[1] : "";
  }

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function scatterQuotesEvenly(items, isQuoteFn) {
  var quotes = [];
  var others = [];

  for (var i = 0; i < items.length; i++) {
    (isQuoteFn(items[i]) ? quotes : others).push(items[i]);
  }

  // No quotes or no others => nothing to scatter
  if (quotes.length === 0 || others.length === 0) return items;

  // Shuffle each group so we don't get patterns
  quotes = shuffle(quotes);
  others = shuffle(others);

  // Place quotes at roughly even intervals through the sequence
  var out = [];
  var total = items.length;
  var qCount = quotes.length;

  for (var idx = 0; idx < total; idx++) {
    var shouldPlaceQuote = false;

    // Positions that should be quotes: round(idx * qCount / total)
    // This spaces them out fairly evenly.
    var targetQuotesSoFar = Math.round((idx * qCount) / total);
    var placedQuotesSoFar = out.filter(isQuoteFn).length;

    if (placedQuotesSoFar < targetQuotesSoFar) shouldPlaceQuote = true;

    if (shouldPlaceQuote && quotes.length) out.push(quotes.shift());
    else if (others.length) out.push(others.shift());
    else if (quotes.length) out.push(quotes.shift());
  }

  return out;
}


  function buildOrderedList(filtered, targetCount, minQuotes, showQuotes) {
    var arr = shuffle((filtered || []).slice());
    var out = arr.slice(0, targetCount);

    function hasQuote(p) {
      var q = showQuotes ? getQuote(p) : "";
      return !!(q && String(q).trim());
    }

    if (showQuotes && minQuotes) {
      var outQuoteCount = 0;
      for (var i = 0; i < out.length; i++) if (hasQuote(out[i])) outQuoteCount++;

      var quotePool = [];
      for (var j = 0; j < arr.length; j++) {
        if (!hasQuote(arr[j])) continue;
        var exists = false;
        for (var k = 0; k < out.length; k++) {
          if (out[k] === arr[j]) { exists = true; break; }
          if (out[k] && out[k].permalink && arr[j].permalink && out[k].permalink === arr[j].permalink) { exists = true; break; }
        }
        if (!exists) quotePool.push(arr[j]);
      }

      var need = Math.max(0, Math.min(minQuotes, out.length, outQuoteCount + quotePool.length) - outQuoteCount);
      if (need > 0) {
        for (var qp = 0; qp < quotePool.length && need > 0; qp++) {
          var replaceIndex = -1;
          for (var r = out.length - 1; r >= 0; r--) {
            if (!hasQuote(out[r])) { replaceIndex = r; break; }
          }
          if (replaceIndex === -1) break;
          out[replaceIndex] = quotePool[qp];
          need--;
        }
      }
    }
    // Scatter quotes through the wall so they aren't bunched at the end
out = scatterQuotesEvenly(out, hasQuote);
return out;

  }

  function toWallKeys(csv) {
    var s = String(csv || "").trim();
    if (!s) return [];
    return s.split(",").map(function (x) { return String(x || "").trim().toLowerCase(); }).filter(Boolean);
  }

  function isTruth(v) {
    return v === true || v === "TRUE" || v === "true" || v === 1 || v === "1";
  }

  function postMatchesWallKeys(p, keys) {
    if (!p || !keys || !keys.length) return false;

    // Support multiple JSON shapes:
    // 1) p.tags.walls = ["cycling", ...]
    // 2) p.walls = {cycling:true, ...}
    // 3) p.tags = { cycling:true } (sheet-style boolean columns)
    var tags = p.tags || {};
    var wallsArr = tags.walls;

    if (Array.isArray(wallsArr)) {
      for (var i = 0; i < keys.length; i++) {
        if (wallsArr.indexOf(keys[i]) >= 0) return true;
      }
    }

    var wallsObj = p.walls || tags.walls || {};
    if (wallsObj && typeof wallsObj === "object" && !Array.isArray(wallsObj)) {
      for (var j = 0; j < keys.length; j++) {
        if (isTruth(wallsObj[keys[j]])) return true;
      }
    }

    if (tags && typeof tags === "object") {
      for (var k = 0; k < keys.length; k++) {
        if (isTruth(tags[keys[k]])) return true;
      }
    }

    return false;
  }

  function initOne(root) {
    if (!root || root.dataset.fpAcwInited === "1") return;
    root.dataset.fpAcwInited = "1";

    var cfgEl = root.querySelector('script[type="application/json"][id^="fp-acw-config-"]');
    var gridEl = root.querySelector("[data-fp-cw-grid]");
    var modalEl = root.querySelector("[data-fp-cw-modal]");
    var modalMediaEl = root.querySelector("[data-fp-cw-modal-media]");
    var modalUserEl = root.querySelector("[data-fp-cw-modal-user]");
    var modalCaptionEl = root.querySelector("[data-fp-cw-modal-caption]");
    var modalLinkEl = root.querySelector("[data-fp-cw-modal-link]");
    var closeEls = root.querySelectorAll("[data-fp-cw-close]");

    if (!cfgEl || !gridEl) return;

    var cfg = safeJsonParse(cfgEl.textContent || "{}");

    // Apply CSS vars
    var minTile = Number(cfg.minTile || 210);
    var gap = Number(cfg.gap || 10);
    gridEl.style.setProperty("--fp-cw-min", minTile + "px");
    gridEl.style.setProperty("--fp-cw-gap", gap + "px");

    var ar = (cfg.tileAspectRatio || "4/5").toString().trim().replace(/\s*/g, "").replace("/", " / ");
    gridEl.style.setProperty("--fp-cw-ar", ar);

    var qSize = clamp(Number(cfg.quoteSize || 100), 85, 150);
    gridEl.style.setProperty("--fp-cw-qs", qSize);

    var wallKeys = toWallKeys(cfg.wallKeysCsv || "");

    function clearModalMedia() {
      if (!modalMediaEl) return;
      var v = modalMediaEl.querySelector("video");
      if (v) {
        try { v.pause(); } catch (e) {}
        v.removeAttribute("src");
        v.load();
      }
      modalMediaEl.innerHTML = "";
    }

    function openModal(p) {
      if (!modalEl) return;
      clearModalMedia();

      var b = postBucket(p);
      if (b === "text") return;

      var username = p && p.username ? String(p.username).trim() : "";
      var captionFull = (p && p.caption && typeof p.caption.full === "string") ? p.caption.full : "";
      var permalink = p && p.permalink ? String(p.permalink) : "#";

      modalEl.classList.remove("fp-cw__modal--embed");

      // YouTube/Vimeo => embed modal
      if (b === "youtube" || b === "vimeo") {
        modalEl.classList.add("fp-cw__modal--embed");

        var url = getModalMediaUrl(p);
        var src = url;

        if (b === "youtube") {
          var id = ytId(url);
          src = id ? ("https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0&playsinline=1") : url;
        } else {
          var vid = vimeoId(url);
          src = vid ? ("https://player.vimeo.com/video/" + vid + "?autoplay=1") : url;
        }

        var iframe = document.createElement("iframe");
        iframe.className = "fp-cw__embed";
        iframe.src = src;
        iframe.allow = "autoplay; fullscreen; picture-in-picture";
        iframe.allowFullscreen = true;
        modalMediaEl.appendChild(iframe);

        if (modalLinkEl) {
          modalLinkEl.href = permalink || "#";
          modalLinkEl.textContent = "View on Instagram";
          modalLinkEl.style.display = "";
        }
        if (modalCaptionEl) modalCaptionEl.textContent = captionFull || "";
        if (modalUserEl) { modalUserEl.textContent = ""; modalUserEl.style.display = "none"; }

      } else {
        // Instagram image/video modal
        var kind = postMediaKind(p);
        var url2 = getModalMediaUrl(p);

        if (kind === "video") {
          var v2 = document.createElement("video");
          v2.controls = true;
          v2.playsInline = true;
          v2.src = url2;
          v2.style.width = "100%";
          v2.style.height = "auto";
          modalMediaEl.appendChild(v2);
        } else {
          var img = document.createElement("img");
          img.alt = "";
          img.src = url2 || "";
          modalMediaEl.appendChild(img);
        }

        if (modalUserEl) { modalUserEl.style.display = ""; modalUserEl.textContent = username ? ("@" + username.replace(/^@/, "")) : ""; }
        if (modalCaptionEl) modalCaptionEl.textContent = captionFull || "";
        if (modalLinkEl) { modalLinkEl.href = permalink || "#"; modalLinkEl.textContent = "View on Instagram"; modalLinkEl.style.display = ""; }
      }

      modalEl.classList.add("fp-cw__modal--open");
      modalEl.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("fp-cw__no-scroll");
    }

    function closeModal() {
      if (!modalEl) return;
      modalEl.classList.remove("fp-cw__modal--open");
      modalEl.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("fp-cw__no-scroll");
      clearModalMedia();
    }

    for (var c = 0; c < closeEls.length; c++) {
      closeEls[c].addEventListener("click", function (e) { e.preventDefault(); closeModal(); });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modalEl && modalEl.classList.contains("fp-cw__modal--open")) closeModal();
    });

    function estimateColumns() {
      var w = gridEl.getBoundingClientRect().width || 0;
      return Math.max(1, Math.floor((w + gap) / (minTile + gap)));
    }

    function loadDataset() {
      if (!cfg.assetUrl) return Promise.reject(new Error("No assetUrl set."));
      return fetch(cfg.assetUrl, { credentials: "same-origin" })
        .then(function (res) {
          if (!res.ok) throw new Error("Fetch failed: " + res.status);
          return res.json();
        })
        .then(function (json) { return normalizePosts(json); });
    }

    function applyLastRowFill(cols) {
      var items = gridEl.querySelectorAll(".fp-cw__item");
      if (!items.length) return;

      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove("fp-cw__item--lastfill-2", "fp-cw__item--lastfill-3", "fp-cw__item--lastfill-4");
      }

      var n = items.length;
      var rem = n % cols;
      if (rem === 0) return;

      var needed = cols - rem;

      // Expand last eligible item to fill (never expand text tiles)
      var last = null;
      for (var j = n - 1; j >= 0; j--) {
        var el = items[j];
        if (el && el.dataset && el.dataset.fpType && el.dataset.fpType !== "text") { last = el; break; }
      }
      if (!last) return;

      var span = 1 + needed;
      if (span >= 2 && span <= 4) last.classList.add("fp-cw__item--lastfill-" + span);
    }

    function render(posts) {
      // Retry briefly if hidden/width=0 (tabs etc)
      var tries = 0;
      (function attempt() {
        var w = gridEl.getBoundingClientRect().width || 0;
        if (w < 40 && tries < 25) {
          tries++;
          setTimeout(attempt, 120);
          return;
        }

        gridEl.innerHTML = "";

        var cols = estimateColumns();
        gridEl.style.setProperty("--fp-cw-cols", String(cols));

        var maxRows = Math.max(1, Number(cfg.maxRows || 4));
        var maxItems = maxRows * cols;

        // Filter by wall keys
        var filtered = [];
        for (var i = 0; i < posts.length; i++) {
          if (postMatchesWallKeys(posts[i], wallKeys)) filtered.push(posts[i]);
        }

        if (!filtered.length) {
          gridEl.innerHTML = '<div style="opacity:.7;padding:0.25rem 0;">No tagged posts for this article yet.</div>';
          return;
        }

        var showQuotes = !!cfg.showQuotes;
        var minQuotes = showQuotes ? 3 : 0;

        var targetCount = Math.min(filtered.length, maxItems);
        if (targetCount <= 0) targetCount = Math.min(filtered.length, cols);

        var out = buildOrderedList(filtered, targetCount, minQuotes, showQuotes);

        var enableFeatured = !!cfg.enableFeatured;
        var featureRate = clamp(Number(cfg.featureRate || 12), 0, 60);
        var quoteMax = clamp(Number(cfg.quoteMaxChars || 120), 40, 220);
        var quoteMaxFeatured = clamp(Number(cfg.quoteMaxCharsFeatured || 260), quoteMax, 400);

        var forcedFeaturedCount = 0;
        var featuredReviewPlaced = false;

        for (var k = 0; k < out.length; k++) {
          var p = out[k];
          var b = postBucket(p);

          // TEXT TILE
          if (b === "text") {
            var quoteT = getQuote(p) || "";
            var unameT = p && p.username ? String(p.username).trim() : "";
            var link = (p && p.permalink != null) ? String(p.permalink).trim() : "";
            if (!/^https?:\/\//i.test(link)) link = "";

            var cardT = document.createElement("div");
            cardT.className = "fp-cw__item fp-cw__item--text";
            cardT.dataset.fpType = "text";

            var smallMax = 90;
            if (quoteT && quoteT.length <= smallMax) cardT.classList.add("fp-cw__item--text-small");

            var qWrapT = document.createElement("div");
            qWrapT.className = "fp-cw__quote fp-cw__quote--text";

            var qTextT = document.createElement("div");
            qTextT.className = "fp-cw__quote-text";
            qTextT.innerHTML = '<span>&ldquo;' + escapeHtml(truncate(quoteT, quoteMax)) + '&rdquo;</span>';
            qWrapT.appendChild(qTextT);

            var uLine = document.createElement("div");
            uLine.className = "fp-cw__text-user";
            uLine.textContent = unameT ? ("- " + unameT.replace(/^@/, "")) : "";
            qWrapT.appendChild(uLine);

            cardT.appendChild(qWrapT);

            if (link) {
              cardT.setAttribute("role", "link");
              cardT.tabIndex = 0;
              cardT.style.cursor = "pointer";
              cardT.addEventListener("click", (function (u) {
                return function (e) { e.preventDefault(); window.open(u, "_blank", "noopener"); };
              })(link));
              cardT.addEventListener("keydown", (function (u) {
                return function (e) {
                  if (e.key === "Enter" || e.key === " ") { e.preventDefault(); window.open(u, "_blank", "noopener"); }
                };
              })(link));
            } else {
              cardT.tabIndex = -1;
              cardT.style.cursor = "default";
              cardT.setAttribute("aria-disabled", "true");
            }

            gridEl.appendChild(cardT);
            continue;
          }

          // MEDIA TILE
          var card = document.createElement("div");
          card.className = "fp-cw__item";
          card.tabIndex = 0;

          var quote = showQuotes ? getQuote(p) : "";
          var hasQuote = !!quote;

          // Same “small review” behaviour as product JS
          var smallReviewMax = Number(cfg.reviewSmallMaxChars || 90);
          var forceSmallReview = hasQuote && (quote || "").length <= smallReviewMax;
          if (forceSmallReview) card.classList.add("fp-cw__item--quote-small");

          // Featured tiles (desktop only)
          if (enableFeatured && window.matchMedia("(min-width: 750px)").matches) {
            var reviewFeatureRate = Number(cfg.reviewFeatureRate || 35);
            var forceFeaturedMin = Number(cfg.reviewForceFeaturedMinChars || 110);
            var forceFeaturedCap = Number(cfg.reviewForceFeaturedCap || 3);
            var quoteLen = (quote || "").length;
            var forceFeaturedReview = hasQuote && !forceSmallReview && quoteLen >= forceFeaturedMin && forcedFeaturedCount < forceFeaturedCap;

            var isFeatured = (Math.random() * 100 < featureRate) || (hasQuote && !forceSmallReview && (Math.random() * 100 < reviewFeatureRate));
            if (forceFeaturedReview) { isFeatured = true; forcedFeaturedCount++; }
            else if (hasQuote && !forceSmallReview && !featuredReviewPlaced) { isFeatured = true; featuredReviewPlaced = true; }

            if (isFeatured && !forceSmallReview) card.classList.add("fp-cw__item--featured");
          }

          var kind = postMediaKind(p);
          var gridUrl = getBestMediaUrl(p, cfg);

          var mediaWrap = document.createElement("div");
          mediaWrap.className = "fp-cw__mediawrap";

          if (kind === "video") {
            var v = document.createElement("video");
            v.className = "fp-cw__media";
            v.src = gridUrl;
            v.muted = true;
            v.loop = true;
            v.playsInline = true;
            v.setAttribute("playsinline", "");
            v.setAttribute("muted", "muted");
            v.setAttribute("preload", "metadata");
            if (cfg.autoplayVideos) {
              v.setAttribute("autoplay", "autoplay");
              v.addEventListener("loadedmetadata", function () {
                try { v.play(); } catch (e) {}
              });
            }
            mediaWrap.appendChild(v);
          } else {
            var img = document.createElement("img");
            img.className = "fp-cw__media";
            img.src = gridUrl;
            img.loading = "lazy";
            img.alt = (p && p.caption && p.caption.full) ? String(p.caption.full).slice(0, 80) : "";
            mediaWrap.appendChild(img);
          }

          card.appendChild(mediaWrap);

          if (hasQuote) {
            var qWrap = document.createElement("div");
            qWrap.className = "fp-cw__quote";

            var qText = document.createElement("div");
            qText.className = "fp-cw__quote-text";
            var qMaxThis = (card.classList.contains("fp-cw__item--featured") ? quoteMaxFeatured : quoteMax);
            qText.innerHTML = "<span>&ldquo;" + escapeHtml(truncate(quote, qMaxThis)) + "&rdquo;</span>";

            qWrap.appendChild(qText);
            card.appendChild(qWrap);
          }

          var username = p && p.username ? String(p.username).trim() : "";
          var overlay = document.createElement("div");
          overlay.className = "fp-cw__overlay";
          overlay.textContent = username ? "@" + username.replace(/^@/, "") : "";
          card.appendChild(overlay);

          card.addEventListener("click", (function (post) { return function () { openModal(post); }; })(p));
          card.addEventListener("keydown", (function (post) {
            return function (e) {
              if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModal(post); }
            };
          })(p));

          gridEl.appendChild(card);
        }

        applyLastRowFill(cols);
      })();
    }

    loadDataset()
      .then(function (posts) {
        posts = posts || [];
        render(posts);

        // Re-render on resize (debounced)
        var resizeTimer = null;
        window.addEventListener("resize", function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () { render(posts); }, 200);
        });
      })
      .catch(function () {
        gridEl.innerHTML = '<div style="opacity:.7;padding:0.25rem 0;">Article content wall could not load.</div>';
      });
  }

  function scan() {
    var nodes = document.querySelectorAll("[data-fp-acw]");
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();
})();
